import { Credits, ResponseError } from '@ynap/api-utils'
import { timeout, delay } from '@ynap/promise-utils'
import { FETCH_STORE_CREDIT_ERROR, FETCH_STORE_CREDIT_REQUEST, FETCH_STORE_CREDIT_SUCCESS } from '../constants'

function onRequest() {
    return {
        type: FETCH_STORE_CREDIT_REQUEST
    }
}

function onSuccess(json) {
    return {
        type: FETCH_STORE_CREDIT_SUCCESS,
        payload: json
    }
}

function onError(error) {
    return {
        type: FETCH_STORE_CREDIT_ERROR,
        error
    }
}

export default function getStoreCreditHistory() {
    return (dispatch, getState, fetch) => {
        const { locale, config, uberToken } = getState()
        const { country } = locale
        const { clientRequest } = config.head || config
        const { baseUrl, clientId } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        const request = Credits.getStoreCreditHistory({ baseUrl, brandId, country, uberToken, clientId })

        //todo look at if this is shareable across state packages
        dispatch(onRequest())

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                if (res.ok) {
                    return res.json()
                }
                throw new ResponseError(res)
            })
            .then((json) => {
                dispatch(onSuccess(json))
            })
            .catch((error) => {
                if (error && error.response) {
                    error.response.json().then((json) => dispatch(onError(json)))
                } else {
                    dispatch(onError(error))
                }
            })
    }
}
